import Uploader from "./components/Uploader";
import StudentPhotoList from "./components/StudentPhotoList";
import SceneScheduleCard from "./components/SceneScheduleCard"; // Import the new component
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { sceneState } from "../../../stores/studioAtoms";
import { getScenes, getSceneSchedule } from "../../../services/apis/StudioApi"; // Import new API functions

const UploadPhotoPage = () => {
    const { schoolId } = useParams();
    const setSceneState = useSetRecoilState(sceneState);
    const [scenesWithSchedules, setScenesWithSchedules] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setSceneState(null);

        const fetchData = async () => {
            setLoading(true);
            try {
                // 1. Fetch Scenes
                const sceneRes = await getScenes(schoolId);
                if (sceneRes.status === 200 && sceneRes.data) {
                    const scenes = sceneRes.data;

                    // 2. Fetch Schedule for each Scene
                    // We map each scene to a promise that fetches its schedule and combines them
                    const scenesData = await Promise.all(scenes.map(async (scene) => {
                        try {
                            const scheduleRes = await getSceneSchedule(scene.id);
                            if (scheduleRes.status === 200) {
                                return { ...scene, schedule: scheduleRes.data };
                            }
                        } catch (err) {
                            console.error(`Failed to fetch schedule for scene ${scene.id}`, err);
                        }
                        return { ...scene, schedule: null };
                    }));

                    setScenesWithSchedules(scenesData);
                }
            } catch (error) {
                console.error("Failed to fetch scenes", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [schoolId, setSceneState]);

    const handleScheduleUpdate = (sceneId, updatedSchedule) => {
        setScenesWithSchedules(prev => prev.map(s => {
            if (s.id === sceneId) {
                return { ...s, schedule: updatedSchedule };
            }
            return s;
        }));
    };

    return (
        <>
            <div className="flex flex-col p-2 w-screen">
                <h2 className="text-xl font-bold mb-4 px-2">촬영별 선택 일정 관리</h2>
                {loading ? (
                    <div className="p-4">Loading scenes...</div>
                ) : (
                    <div className="flex flex-wrap gap-4 mb-6 px-2">
                        {scenesWithSchedules.map(scene => (
                            <SceneScheduleCard
                                key={scene.id}
                                scene={scene}
                                schedule={scene.schedule}
                                onUpdate={(updated) => handleScheduleUpdate(scene.id, updated)}
                            />
                        ))}
                    </div>
                )}
            </div>
            <div className="flex flex-col md:flex-row w-screen border-t pt-4">
                <div className="md:w-1/3 p-2">
                    <Uploader />
                </div>
                <div className="md:w-2/3 p-2">
                    <StudentPhotoList />
                </div>
            </div>
        </>
    )
}

export default UploadPhotoPage;